import * as React from 'react'

function IconAssistant(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={134}
      height={133}
      viewBox="0 0 134 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M133.53 66.5c0-36.727-29.773-66.5-66.5-66.5C30.303 0 .53 29.773.53 66.5c0 36.727 29.773 66.5 66.5 66.5 36.727 0 66.5-29.773 66.5-66.5z"
        fill="#F4BA27"
      />
      <path
        d="M105.877 82.936a7.892 7.892 0 01-7.755 7.714 5.685 5.685 0 01-.642 0 5.032 5.032 0 00-4.812 2.56c-5.69 10.332-16.534 15.445-27.182 15.25-10.755-.512-21.33-6.414-26.297-17.306a4.364 4.364 0 00-4.161-2.544h-.415a7.893 7.893 0 01-7.811-7.6 7.836 7.836 0 018.08-8.04 1.527 1.527 0 001.625-1.365c2.187-22.346 16.891-33.27 31.23-32.913 14.315.569 28.271 12.404 29.027 34.815a1.569 1.569 0 001.529 1.512 7.826 7.826 0 017.584 7.917z"
        fill="#fff"
      />
      <path
        d="M95.382 81.733a.577.577 0 01-.422-.211.564.564 0 01-.061-.643.56.56 0 01.15-.17c.13-.106 3.195-2.439 8.177-1.146a.553.553 0 01.399.682.564.564 0 01-.683.399c-4.422-1.179-7.088.813-7.202.934a.545.545 0 01-.358.155z"
        fill="#000"
      />
      <path
        d="M102.121 83.416a.544.544 0 01-.447-.26 5.693 5.693 0 00-3.804-2.561.553.553 0 01-.433-.817.552.552 0 01.547-.288 6.72 6.72 0 014.625 3.064.554.554 0 01.094.444.554.554 0 01-.265.369.57.57 0 01-.317.049zM38.157 79.888a.602.602 0 01-.358-.147c-.105-.097-2.633-2.292-7.12-1.406a.554.554 0 11-.22-1.089c5.072-1.008 7.966 1.56 8.129 1.626a.553.553 0 010 .813.554.554 0 01-.431.203z"
        fill="#000"
      />
      <path
        d="M31.321 81.123a.544.544 0 01-.309-.105.56.56 0 01-.122-.813 6.763 6.763 0 014.812-2.764.563.563 0 01.586.537.554.554 0 01-.537.577 5.626 5.626 0 00-3.958 2.308.553.553 0 01-.472.26zM67.144 86.529a.554.554 0 01-.513-.398.554.554 0 01.366-.691c4.398-1.334 4.699-2.065 4.715-2.203.04-.301-1.04-.935-1.683-1.317a7.429 7.429 0 01-2.65-2.138c-1.585-2.666-.512-12.477-.382-13.59a.553.553 0 01.618-.489.545.545 0 01.488.618c-.333 2.91-.943 10.909.236 12.884a6.87 6.87 0 002.251 1.756c1.211.715 2.358 1.39 2.227 2.438-.13 1.049-1.08 1.789-5.494 3.13a.677.677 0 01-.18 0zM68.713 91.317a6.502 6.502 0 01-6.503-5.422.561.561 0 01.487-.618.56.56 0 01.618.48c0 .187.634 4.413 5.625 4.446a.593.593 0 01.553.569.569.569 0 01-.561.553l-.22-.008zM83.644 78.827c.05-1.534-.62-2.801-1.494-2.83-.875-.028-1.625 1.194-1.674 2.728-.05 1.535.62 2.801 1.494 2.83.875.028 1.625-1.193 1.674-2.728zM54.438 77.888c.05-1.535-.62-2.802-1.494-2.83-.875-.028-1.625 1.193-1.674 2.727-.05 1.535.62 2.802 1.494 2.83.875.028 1.625-1.193 1.674-2.727z"
        fill="#000"
      />
      <path
        d="M34.881 72.954s-15.826-2.3-12.786-16.054c3.04-13.753 7.999-12.079 11.315-20.492 3.317-8.413 17.07-15.29 31.97-9.324 14.9 5.967 25.686-5.568 35.652-1.739 9.965 3.829 1.756 11.778 3.333 15.33 1.577 3.553 8.047 5.74 5.958 13.892-2.089 8.153-6.584 22.126-12.778 20.216-5.227-1.626-4.414-22.126-12.966-25.296-7.844-2.91-19.581 8.519-33.96 3.251a3.177 3.177 0 00-4.252 2.666c-.699 6.528-3.121 17.802-11.486 17.55z"
        fill="#E84E25"
      />
      <path
        d="M47.18 71.02a.643.643 0 01-.268-.082.554.554 0 01-.195-.764c0-.065 4.178-6.852 11.583-4.763a.57.57 0 01.382.69.56.56 0 01-.691.383c-6.584-1.862-10.283 4.194-10.315 4.26a.578.578 0 01-.496.275zM88.522 72.076a.57.57 0 01-.48-.309c-.138-.26-3.349-6.348-10.022-4.877a.568.568 0 01-.666-.43.56.56 0 01.43-.66c7.52-1.625 11.21 5.423 11.25 5.496a.555.555 0 01-.244.748.544.544 0 01-.268.032z"
        fill="#000"
      />
      <path
        d="M52.643 89.465c4.21-.735 7.383-2.707 7.086-4.406-.296-1.698-3.95-2.479-8.16-1.744-4.21.735-7.382 2.707-7.086 4.405.296 1.698 3.95 2.48 8.16 1.745zM89.528 89.421C90 87.763 87.05 85.47 82.94 84.3c-4.11-1.17-7.826-.776-8.298.882-.472 1.658 2.477 3.951 6.588 5.122 4.11 1.17 7.825.776 8.297-.882z"
        fill="#FFDEDE"
      />
    </svg>
  )
}

export default IconAssistant
